import React from 'react';
import { Card } from 'react-bootstrap-5';

type PermissionCardProps = {
  checked: boolean;
  label: string;
  name?: string;
  subtitle?: string;
  onClick: () => void;
};

const PermissionCard = ({ checked, label, subtitle = '', name = '', onClick } : PermissionCardProps) => {
  return (
    <Card className="h-100">
      <Card.Body>
        <label className="d-flex align-items-start gap-2 fw-normal clickable">
          <input
            checked={checked}
            className="mt-1 flex-shrink-0 clickable"
            name={name}
            type="radio"
            onChange={onClick}
          />
          <span>
            <span className="d-block">{label}</span>
            <span className="d-block fw-light small mt-1">{subtitle}</span>
          </span>
        </label>
      </Card.Body>
    </Card>
  );
};
export default PermissionCard;
